import { ASESOR_CIERRE_ROLE, ASESOR_ROLE, CORDINATOR_ROLE, GENERAL_PRINCIPAL_ROLE, MASTER_ROLE, REGIONAL_PRINCIPAL_ROLE, SUPERVISOR_ROLE } from "@/constants/roles";

export function normalizeNoAccents(str: string) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function escapeRegex(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function capitalizeWords(str: string) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatWithCommas(number: number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCurrency(value: number, currency: string = "MXN") {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}

export const getRole = (role: string) => {
  const isAsesor = [ASESOR_CIERRE_ROLE, ASESOR_ROLE].includes(role);
  const isRegionalPrincipal = [REGIONAL_PRINCIPAL_ROLE].includes(role);
  const isAdmin = [GENERAL_PRINCIPAL_ROLE].includes(role);
  const isMaster = [MASTER_ROLE].includes(role);
  const isCordinator = [CORDINATOR_ROLE, SUPERVISOR_ROLE].includes(role);

  return {
    isAdmin,
    isAsesor,
    isMaster,
    isCordinator,
    isRegionalPrincipal,
  };
};